<app-breadcrumbs></app-breadcrumbs>
<div class="store-number-toolbar">
  <div [cfaLoading]="isLoading">
    <button mat-raised-button (click)="getRestaurantNetwork()" color="primary" id="store-number-search-button"
      [disabled]=isStoreNumberInvalid()>
      <mat-icon>search</mat-icon>
    </button>
    <mat-form-field id="store-number-search-field" appearance="outline">
      <mat-label>Store Number</mat-label>
      <input matInput type="number" maxlength="5" minLength="5" (keydown.enter)="isStoreNumberInvalid() ? $event.preventDefault() : getRestaurantNetwork()"
        [(ngModel)]="storeNumberInput" autofocus [disabled]="isLoading" />
    </mat-form-field>
  </div>
  <app-health-nav [storeNumber]="formattedStoreNumber"></app-health-nav>
</div>

@for (location of location; track location) {
  <div class="location-info-bar">
    <span class="info-chip">
      <mat-icon>perm_identity</mat-icon>
      {{location.operator.name}}
    </span>
    <span class="info-chip">
      <mat-icon>location_on</mat-icon>
      {{location.core.locationName}}
    </span>
    <span class="info-chip">
      <mat-icon>landscape</mat-icon>
      {{location.fieldOpsHierarchy.regionName}}
    </span>
    <span class="info-chip">
      <mat-icon>access_time</mat-icon>
      {{location.core.timeZone.timeZoneName.split(" ")[2]}}
    </span>
    @if (location.locationStatus.locationStatus == 'open' && !location.locationStatus.tempCloseFlag) {
      <span class="info-chip chip-healthy">
        <mat-icon>check_circle_outline</mat-icon>
        {{location.locationStatus.locationStatus}}
      </span>
    }
    @if (location.locationStatus.locationStatus != 'open' || location.locationStatus.tempCloseFlag) {
      @if (!location.locationStatus.tempCloseFlag) {
        <span class="info-chip chip-unhealthy">
          <mat-icon>not_interested</mat-icon>
          {{location.locationStatus.locationStatus}}
        </span>
      }
      @if (location.locationStatus.tempCloseFlag) {
        <span class="info-chip chip-unhealthy">
          <mat-icon>not_interested</mat-icon>
          {{location.locationStatus.tempCloseReason}}
        </span>
      }
    }
    @for (mostRecentRemodel of mostRecentRemodels; track mostRecentRemodel) {
      <span class="info-chip" matTooltip="Projected reopen date">
        <mat-icon>calendar_today</mat-icon>
        {{mostRecentRemodel.remodelProjectedReopenDate}}
      </span>
    }
    @if (networkState === NETWORK_STATE.ON_WAN1) {
      <span class="info-chip chip-healthy" [matTooltip]="networkStateEvaluation?.tooltip"
        [matTooltipClass]="'my-tooltip'">
        <mat-icon>check_circle</mat-icon>
        On WAN1
      </span>
    }
    @if (networkState === NETWORK_STATE.ON_WAN2) {
      <span class="info-chip chip-warning" [matTooltip]="networkStateEvaluation?.tooltip"
        [matTooltipClass]="'my-tooltip'">
        <mat-icon>signal_cellular_alt</mat-icon>
        On WAN2
      </span>
    }
    @if (networkState === NETWORK_STATE.EM_FAILOVER) {
      <span class="info-chip chip-unhealthy" [matTooltip]="networkStateEvaluation?.tooltip"
        [matTooltipClass]="'my-tooltip'">
        <mat-icon>priority_high</mat-icon>
        EM Failover
      </span>
    }
    @if (networkState === NETWORK_STATE.OFFLINE) {
      <span class="info-chip chip-unhealthy" [matTooltip]="networkStateEvaluation?.tooltip"
        [matTooltipClass]="'my-tooltip'">
        <mat-icon>block</mat-icon>
        Offline
      </span>
    }
    @if (networkState === NETWORK_STATE.UNKNOWN) {
      <span class="info-chip chip-warning" [matTooltip]="networkStateEvaluation?.tooltip"
        [matTooltipClass]="'my-tooltip'">
        <mat-icon>help_outline</mat-icon>
        Circuit Unknown
      </span>
    }
    @if (location.locationTypeCodes.foodTruckFlag) {
      <span class="info-chip">
        <mat-icon>local_shipping</mat-icon>
        Food Truck
      </span>
    }
    @if (location.mes) {
      <span class="info-chip" matTooltip="Location's MES">
        <mat-icon>build</mat-icon>
        {{ location.mes }}
      </span>
    }
    @if (storeDashboardLinkFromLogicMonitor != null) {
      <a class="info-chip info-link" [href]="storeDashboardLinkFromLogicMonitor" target="_blank">
        <mat-icon>link</mat-icon>
        LogicMonitor
      </a>
    }
    @if (storeDashboardLinkFromNetbox != null) {
      <a class="info-chip info-link" *appHasAnyAuthority="['ADMIN']" [href]="storeDashboardLinkFromNetbox" target="_blank">
        <mat-icon>link</mat-icon>
        NetBox
      </a>
    }
    @if (mistSiteLink != null) {
      <a class="info-chip info-link" [href]="mistSiteLink" target="_blank">
        <mat-icon>link</mat-icon>
        Mist
      </a>
    }
  </div>
}

@if (storeIsNotFound) {
  <div class="not-found-message">
    <p>The location requested either does not exist or has been permanently closed.
      You can check by searching in Permanent Closures or Location Overview.</p>
  </div>
}

@if (!storeIsNotFound && !isLoading && location.length > 0) {

  <div class="device-board">

    <!-- Column 1: Routers (FortiGate) + Cradlepoint Routers -->
    @if (fortigates.length > 0 || cradlepoints.length > 0) {
      <div class="board-column routers-column">

        @if (fortigates.length > 0) {
          <div class="zone">
            <div class="zone-header">
              <span class="status-dot status-{{getSectionSeverity('fortigate')}}"></span>
              <h3 class="zone-title">Routers</h3>
              <span class="device-count">{{fortigates.length}}</span>
            </div>
            @for (fortigate of fortigates; track fortigate) {
              <div class="device-card-wrap" [class.is-online]="fortigate.conn_status === 1"
                [class.is-warn]="fortigate.conn_status === 0" [class.is-offline]="fortigate.conn_status === 2">
                <app-fortigate-card [fortigate]="fortigate"></app-fortigate-card>
              </div>
            }
          </div>
        }

        @if (cradlepoints.length > 0) {
          <div class="zone">
            <div class="zone-header">
              <span class="status-dot status-{{getSectionSeverity('cradlepoint')}}"></span>
              <h3 class="zone-title">Cradlepoint Routers</h3>
              <span class="device-count">{{cradlepoints.length}}</span>
            </div>
            @for (cradlepoint of cradlepoints; track cradlepoint) {
              <div class="device-card-wrap" [class.is-online]="cradlepoint.state === 'online'" [class.is-offline]="cradlepoint.state !== 'online'">
                <app-cradlepoint-card [cradlepoint]="cradlepoint"></app-cradlepoint-card>
              </div>
            }
          </div>
        }

      </div>
    }

    <!-- Column 2: Lumen Fiber (Circuit) + Fiber NID -->
    @if (circuits.length > 0 || fiberNid != null) {
      <div class="board-column circuit-column">

        @if (circuits.length > 0) {
          <div class="zone">
            <div class="zone-header">
              <span class="status-dot status-{{getSectionSeverity('circuit')}}"></span>
              <h3 class="zone-title">Circuit</h3>
            </div>
            @for (circuit of circuits; track circuit) {
              <div class="device-card-wrap" [class.is-online]="circuit.loss === 0" [class.is-offline]="circuit.loss !== 0">
                <app-circuit-card [circuit]="circuit"></app-circuit-card>
              </div>
            }
          </div>
        }

        @if (fiberNid != null) {
          <div class="zone">
            <div class="zone-header">
              <span class="status-dot status-neutral"></span>
              <h3 class="zone-title">Fiber NID</h3>
            </div>
            <app-fiber-nid-card [fiberNid]="fiberNid"></app-fiber-nid-card>
          </div>
        }

      </div>
    }

    <!-- Column 3: Switches -->
    @if (merakiSwitchStatuses.length > 0) {
      <div class="board-column switch-column">
        <div class="zone">
          <div class="zone-header">
            <span class="status-dot status-{{getSectionSeverity('meraki')}}"></span>
            <h3 class="zone-title">Switches</h3>
            <span class="device-count">{{merakiSwitchStatuses.length}}</span>
          </div>
          @for (meraki_switch_status of merakiSwitchStatuses; track meraki_switch_status) {
            <div class="device-card-wrap" [class.is-online]="meraki_switch_status.status === 'online'" [class.is-offline]="meraki_switch_status.status !== 'online'">
              <app-meraki-card [meraki_switch_status]="meraki_switch_status"></app-meraki-card>
            </div>
          }
        </div>
      </div>
    }

    <!-- Column 4: Access Points (compact, expandable) -->
    @if (mists.length > 0) {
      <div class="board-column ap-column">
        <div class="zone">
          <div class="zone-header">
            <span class="status-dot status-{{getSectionSeverity('mist')}}"></span>
            <h3 class="zone-title">Access Points</h3>
            <span class="device-count">{{mists.length}}</span>
            <button mat-button class="zone-action" (click)="allApsExpanded ? collapseAllAps() : expandAllAps()">
              <mat-icon>{{allApsExpanded ? 'unfold_less' : 'unfold_more'}}</mat-icon>
              {{allApsExpanded ? 'Collapse' : 'Expand'}}
            </button>
          </div>
          <div class="ap-grid">
            @for (ap of mists; track ap) {
              <div class="ap-card" [class.is-online]="ap.connected" [class.is-offline]="!ap.connected">
                <button type="button" class="ap-card-head" (click)="toggleAp(ap.mac)">
                  <span class="status-dot" [class.status-green]="ap.connected" [class.status-red]="!ap.connected"></span>
                  <span class="ap-name">{{ap.name || ap.mac || 'Access Point'}}</span>
                  <span class="ap-model">{{ap.model}}</span>
                  <mat-icon class="ap-expand-icon">{{expandedAps[ap.mac] ? 'expand_less' : 'expand_more'}}</mat-icon>
                </button>
                @if (expandedAps[ap.mac]) {
                  <div class="ap-details">
                    <p><b>Status:</b> {{ap.connected ? 'Online' : 'Offline'}}</p>
                    <p><b>Mac:</b> {{ap.mac}}</p>
                    <p><b>Serial:</b> {{ap.serial}}</p>
                    <p><b>HW Rev:</b> {{ap.hw_rev || 'Unknown'}}</p>
                    <p><b>Eth0 Speed:</b> {{ap.eth0_port_speed}}</p>
                    <p><b>LLDP System:</b> {{ap.lldp_system_name}}</p>
                    <p><b>LLDP Port:</b> {{ap.lldp_port_id}}</p>
                    <p><b>Uptime:</b> {{formatUptime(ap.uptime)}}</p>
                  </div>
                }
              </div>
            }
          </div>
        </div>
      </div>
    }

  </div>
}
